export enum ResponseType {
    START_GAME = "START_GAME",
    NEW_ACTION = "NEW_ACTION",
    NEW_TURN = "NEW_TURN",
    KICK_PARTICIPANT = "KICK_PARTICIPANT",
    UPDATE_PARTICIPANTS = "UPDATE_PARTICIPANTS",
    REFRESH_TURN = "REFRESH_TURN"
}